import "./App.css";
import Map from "./map";
import Header from "./header";
import { GipContext, ThemeContext } from "state";
import { useGip, useQuery, useTheme } from "hooks";
import { SWRConfig } from "swr";
import QueryContext from "state/query";
import { ProjectList } from "./projects";
import ProjectDetail from "./projects/detail";
import Loader from "./loader";

function App() {
  const theme = useTheme();

  const { loading, processQuery, activeProject, ...gips } = useGip();
  const query = useQuery(processQuery);

  return (
    <SWRConfig>
      <ThemeContext.Provider value={theme}>
        <QueryContext.Provider value={query}>
          <GipContext.Provider
            value={{
              activeProject,
              ...gips,
            }}
          >
            <div className="App relative">
              {loading && <Loader />}
              <Header />
              <div className="h-full flex-auto relative">
                <Map />
                <ProjectList />
                <ProjectDetail {...activeProject} />
              </div>
            </div>
          </GipContext.Provider>
        </QueryContext.Provider>
      </ThemeContext.Provider>
    </SWRConfig>
  );
}

export default App;
